export default __webpack_public_path__ + "static/media/arab-min.393f9fae.webp";